import React, { useEffect } from "react";
//@ts-ignore
import style from "./Form.module.css";
import RucForm from "./RucForm/RucForm";
import DocumentForm from "./DocumentForm/DocumentForm";
import Button from "@Atoms/buttons/buttonsWithoutIcons/button";
import Icon from "@Atoms/Icon/Icon";
import { TimesIcon } from "@Models/icons";
import {
  CARNET_DE_EXTRANJERIA,
  DNI,
  PASAPORTE,
  RUC,
} from "./constants/constants";
import { isEmailValid, isValidDate } from "./FormFunctions/FormFunctions";
import { validatePhoneNumber } from "@Models/phoneCountryCodes";

const Form = ({
  title = "Cliente nuevo",
  subTitle = "Completa los siguientes datos.",
  backClick,
  nextClick = () => {},
  width = "",
  form = {
    name: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    codeCountryPhone: "51",
    phoneRefused: false,
    documentType: "DNI",
    documentNumber: "",
    categoryClientId: "",
    sex: "",
    birthdate: "",
    address: "",
  },
  status = {
    error: false,
    validated: false,
    loading: false,
    message: "",
  },
  setForm,
  textButton = "Siguiente",
  edit = false,
  isLoading = false,
  forceDisabled = false,
  categories = [],
  searchingInReniec,
}) => {
  const [isDisabled, setIsDisabled] = React.useState(true);

  useEffect(() => {
    // Validación simplificada: solo bloquear si el cliente ya está registrado
    // Campos mínimos requeridos:
    // - RUC: nombre (razón social) + número de RUC + dirección
    // - Otros documentos: nombre y apellido

    // El teléfono es obligatorio en el alta. Si el cliente no quiere darlo, el
    // formulario ofrece la casilla "no desea brindar su teléfono": así nadie
    // tiene que inventar un número que después se manda a WhatsApp, ensucia la
    // búsqueda del POS y aparece como contactable en el Excel de clientes.
    const hasValidPhone =
      !!form.phoneNumber &&
      !validatePhoneNumber(form.phoneNumber, form.codeCountryPhone);
    const hasPhoneOrRefusal = form.phoneRefused === true || hasValidPhone;

    const hasRequiredFields = form.name && form.lastName && hasPhoneOrRefusal;
    const hasRequiredFieldsRUC =
      form.name && form.documentNumber && form.address && hasPhoneOrRefusal;

    // El carné de extranjería admite entre 8 y 12 caracteres; si se ingresó
    // uno incompleto no se permite guardar (SUNAT rechaza el comprobante).
    const isCarnetIncomplete =
      form.documentType === CARNET_DE_EXTRANJERIA &&
      !!form.documentNumber &&
      form.documentNumber.length < 8;

    // Solo bloquear si:
    // 1. Está buscando en Reniec
    // 2. Está forzadamente deshabilitado
    // 3. El cliente ya está registrado
    // 4. No tiene los campos mínimos requeridos

    const isBlocked =
      searchingInReniec ||
      forceDisabled === true ||
      status.message === "Cliente ya registrado." ||
      isCarnetIncomplete ||
      (form.documentType === RUC ? !hasRequiredFieldsRUC : !hasRequiredFields);

    if (isBlocked) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [form, status, forceDisabled, searchingInReniec]);

  useEffect(() => {
    if (!edit) {
      setForm({
        name: "",
        lastName: "",
        email: "",
        codeCountryPhone: "51",
        phoneNumber: "",
        phoneRefused: false,
        documentType: form.documentType,
        documentNumber: "",
        categoryClientId: "",
        sex: "",
        birthdate: "",
        address: "",
      });
    }
  }, [form.documentType]);

  return (
    <form
      className={style.containerForm}
      style={{ width: width }}
      onSubmit={(e) => {
        e.preventDefault();
        nextClick();
      }}
    >
      <header>
        <h1>{title}</h1>
        <button onClick={backClick} type="button" className={style.closeButton}>
          <Icon path={TimesIcon} color={"#ACACAC"} size={18} />
        </button>
      </header>
      <main>
        <h3 className={style.subTitle}>{subTitle}</h3>
        {form.documentType === RUC ? (
          <RucForm
            form={form}
            setForm={setForm}
            status={status}
            edit={edit}
            isLoading={isLoading}
            categories={categories}
            searchingInReniec={searchingInReniec}
          />
        ) : (
          <DocumentForm
            form={form}
            setForm={setForm}
            status={status}
            edit={edit}
            isLoading={isLoading}
            categories={categories}
            searchingInReniec={searchingInReniec}
          />
        )}
      </main>
      <footer>
        <Button
          isPrimary={true}
          isDisabled={isDisabled || isLoading || searchingInReniec}
          textBttn={textButton}
          handleClick={() => {
            nextClick();
          }}
          isLoading={isLoading}
          buttonProps={{ "data-testid": "btn-save-client" }}
        />
      </footer>
    </form>
  );
};

export default Form;
